/**
 *
 * Legends display under the deck canvas in Maintenance page in mobile sized screen mode.
 *
 * @file   Legend.js
 * @author Lateral
 * @since  2023
 */
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { ReactComponent as ReplaceIcon } from 'assets/icons/Replace.svg'
import { ReactComponent as RotateIcon } from 'assets/icons/Rotate.svg'
import { ReactComponent as SwapIcon } from 'assets/icons/Swap.svg'
import { ReactComponent as RelocateFromIcon } from 'assets/icons/Relocate-From.svg'
import { ReactComponent as RelocateToIcon } from 'assets/icons/Relocate-To.svg'
import { ReactComponent as ViewResult } from 'assets/icons/ViewResult.svg'
import { ReactComponent as Patch } from 'assets/icons/patched.svg'

const Item = ({ title, children, ...restStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        ...restStyles
      }}>
      <Typography variant="h6" component="h6">
        {title}
      </Typography>

      <div>{children}</div>
    </Box>
  )
}

const IconItem = ({ title, backgroundColor }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        marginRight: '.2em'
      }}>
      <Box sx={[iconStyling, { backgroundColor }]} />
      <Typography>{title}</Typography>
    </div>
  )
}

const ItemMaintenance = ({ title, children }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        marginRight: '.2em',
        alignItems: 'center'
      }}>
      {children} {title}
    </div>
  )
}

const iconStyling = { height: '20px', width: '20px', verticalAlign: 'top', marginRight: '.4em' }

function Legend() {
  /**
   * Generates a Legend box for mobile sized screen view
   * of maintenance page
   *
   * @function
   *
   *
   * @returns {object} - A box with maintenance legends
   */
  return (
    <Box
      sx={{
        marginBottom: '1em',
        marginTop: '1em',
        display: 'flex',
        justifyContent: 'space-between',
        userSelect: 'none',
        flexWrap: 'wrap'
      }}>
      <Item title="Life Remaining">
        <Stack display="flex" alignItems="center" flexDirection="row" mt={1}>
          <IconItem title="0%" backgroundColor="heatmap.zero" />
          <IconItem title="20%" backgroundColor="heatmap.twenty" />
          <IconItem title="40%" backgroundColor="heatmap.forty" />
          <IconItem title="60%" backgroundColor="heatmap.sixty" />
          <IconItem title="80%" backgroundColor="heatmap.eighty" />
        </Stack>
      </Item>

      <Item title="Maintenance Actions" mt={1}>
        <Box display="flex" gap="1em" flexWrap="wrap" mt={1}>
          <Stack display="flex" alignItems="center" flexDirection="row">
            <ItemMaintenance title="Replace">
              <ReplaceIcon style={iconStyling} />
            </ItemMaintenance>
            <ItemMaintenance title="Rotate">
              <RotateIcon style={iconStyling} />
            </ItemMaintenance>
            <ItemMaintenance title="Swap">
              <SwapIcon style={iconStyling} />
            </ItemMaintenance>
            <ItemMaintenance title="Rotate From">
              <RelocateFromIcon style={iconStyling} />
            </ItemMaintenance>
          </Stack>

          <Stack display="flex" alignItems="center" flexDirection="row">
            <ItemMaintenance title="Rotate To">
              <RelocateToIcon style={iconStyling} />
            </ItemMaintenance>
            <ItemMaintenance title="Patched">
              <Patch style={iconStyling} />
            </ItemMaintenance>
            <ItemMaintenance title="View Wear Results">
              <ViewResult style={iconStyling} />
            </ItemMaintenance>
          </Stack>
        </Box>

        {/* <Grid flexDirection="row" item xs={12} container spacing={1}>
          <Grid item>
            <ReplaceIcon style={iconStyling} /> Replace
          </Grid>
          <Grid item>
            <RotateIcon style={iconStyling} /> Rotate
          </Grid>
          <Grid item>
            <SwapIcon style={iconStyling} /> Swap
          </Grid>
          <Grid item>
            <RelocateFromIcon style={iconStyling} /> Relocate From
          </Grid>
        </Grid> */}
      </Item>
    </Box>
  )
}

export default Legend
